import React, { Component } from 'react';
import styled from 'styled-components';

import { SectionChild } from '../components/section';
import ManagedComponent from '../components/managed-component';
import { isiOS } from '../themes';

const SliderWrapper = styled.div`
  flex-grow: 1; 
`;

// excess height to improve interactive area / accessibility
const height = '36px';
const thumbHeight = 24;
const trackHeight = isiOS() ? '2px' : '3px';
const shadowHeight = isiOS() ? '-11px' : '-10px';

// colours
const upperColor = isiOS() ? '#e0e0e0' : '#9EE0E4';
const lowerColor = "#00AFB7";
const thumbColor = isiOS() ? 'white' : lowerColor;
const upperBackground = `linear-gradient(to bottom, ${upperColor}, ${upperColor}) 100% 50% / 100% ${trackHeight} no-repeat transparent`;
const lowerBackground = `linear-gradient(to bottom, ${lowerColor}, ${lowerColor}) 100% 50% / 100% ${trackHeight} no-repeat transparent`;

const makeLongShadow = (color, size) => {
  let i = 12;
  let shadow = `${i}px 0 0 ${size} ${color}`;

  for (; i < 706; i++) {
    shadow = `${shadow}, ${i}px 0 0 ${size} ${color}`;
  }

  return shadow;
};

const SliderInput = styled.input`
  overflow: hidden;
  display: block;
  appearance: none;
  max-width: 700px;
  width: 100%;
  margin: 0;
  height: ${height};
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: ${height};
    background: ${lowerBackground};
  }

  &::-webkit-slider-thumb {
    position: relative;
    appearance: none;
    height: ${thumbHeight}px;
    width: ${thumbHeight}px;
    background: ${thumbColor};
    border-radius: 100%;
    border: ${isiOS() ? '1px solid grey' : 0};
    top: 50%;
    transform: translateY(-50%);
    box-shadow: ${makeLongShadow(upperColor, shadowHeight)};
    transition: background-color 150ms;
  }

  &::-moz-range-track,
  &::-moz-range-progress {
    width: 100%;
    height: ${height};
    background: ${upperBackground};
  }

  &::-moz-range-progress {
    background: ${lowerBackground};
  }

  &::-moz-range-thumb {
    appearance: none;
    margin: 0;
    height: ${thumbHeight};
    width: ${thumbHeight};
    background: ${thumbColor};
    border-radius: 100%;
    border: 0;
    transition: background-color 150ms;
  }

  &::-ms-track {
    width: 100%;
    height: ${height};
    border: 0;
    /* color needed to hide track marks */
    color: transparent;
    background: transparent;
  }

  &::-ms-fill-lower {
    background: ${lowerBackground};
  }

  &::-ms-fill-upper {
    background: ${upperBackground};
  }

  &::-ms-thumb {
    appearance: none;
    height: ${thumbHeight};
    width: ${thumbHeight};
    background: ${thumbColor};
    border-radius: 100%;
    border: 0;
    transition: background-color 150ms;
    /* IE Edge thinks it can support -webkit prefixes */
    top: 0;
    margin: 0;
    box-shadow: none;
  }
`;

class Slider extends Component {
  static _type = 'Slider';
  static _listType = true;

  onChange = ({ currentTarget: { value } }) => {
    const { onChange } = this.props;

    if (typeof onChange === 'function') {
      onChange(value);
    }
  };

  render() {
    const { label, min, max, step, value } = this.props;

    return (
      <SectionChild>
        <div className="item-content">
          <div className="item-inner">
            <div className="item-title">{label}</div>
            <SliderWrapper className="item-after">
              <div className="range-slider">
                <SliderInput
                  type="range"
                  min={min}
                  max={max}
                  step={step}
                  value={value}
                  onChange={this.onChange}
                />
              </div>
            </SliderWrapper>
          </div>
        </div>
      </SectionChild>
    );
  }
}

export default class extends Component {
  parseValue(rawValue) {
    return parseFloat(rawValue, 10);
  }

  render() {
    const {
      label,
      value,
      min,
      max,
      step,
      onChange,
      settingsKey
    } = this.props;

    const sliderProps = {
      label,
      value,
      min,
      max,
      step,
      onChange
    };

    if (!settingsKey) {
      return (
        <Slider {...sliderProps} />
      );
    }

    return (
      <ManagedComponent settingsKey={settingsKey}>
        {({ value, onChange }) => (
          <Slider
            {...sliderProps}
            value={this.parseValue(value)}
            onChange={(value) => {
              if (typeof sliderProps.onChange === 'function') {
                sliderProps.onChange(value);
              }
              onChange(value.toString());
            }}
          />
        )}
      </ManagedComponent>
    );
  }
}



// WEBPACK FOOTER //
// ./src/fitbit-components/slider.js